import type { SuggestedQuestion } from "../types/suggestquestions";
import type { DetectQuestionsResponse } from "../types/detectQuestions";
import { apiUrl } from "./base";

export async function detectQuestions(input: {
  recentTranscript: string;
  suggestedQuestions?: SuggestedQuestion[];
  alreadyAsked: string[];
  sessionId?: string | null;
  contactType?: string | null;
  mode?: "adhoc" | "suggestionsList";
  signal?: AbortSignal;
}): Promise<DetectQuestionsResponse> {
  const res = await fetch(apiUrl("/api/detectQuestions"), {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(input),
    signal: input.signal,
  });

  if (!res.ok) {
    throw new Error(await res.text());
  }

  return (await res.json()) as DetectQuestionsResponse;
}
